<template>
  <div class="follow-page">
    <div class="follow-home" >
      <div class="top-info flex-center-between ">
        <div class="flex-column-start">
          <div class="title">{{$t('follow.desc1')}}</div>
          <div class="btn" @click="toPath('tradeApply')">
            {{$t('follow.btn5')}}
          </div>
        </div>
        <div>
          <img :src="bgUrl" alt="">
        </div>
      </div>

      <div class="user-statistics flex-center-between">
        <div class="flex-center header">
          <img :src="headerUrl" alt="">
          <span>zuo***6099@gmail.com</span>
        </div>
        <div class="">
          <div class="label">
            {{ $t('account.label6') }} <span class="gray">(USDT)</span>
          </div>
          <div class="value green">+1233.11</div>
        </div>
        <div class="">
          <div class="label">
            {{ $t('gen-dan-zong-shou-yi') }} <span class="gray">(USDT)</span>
          </div>
          <div class="value green">+1233.11</div>
        </div>
        <div class="btn">
          <Button>{{ $t('follow.tab2') }}</Button>
        </div>
      </div>

      <div class="user-list">
        <div class="title">{{ $t('dai-dan-jiao-yi-yuan') }}</div>
        <div class="tabs flex">
          <div class="tab" :class="tabIndex == 1 ? 'active' : ''" @click="changeTab(1)">{{ $t('tradeFollow.title2') }}</div>
          <div class="tab" :class="tabIndex == 2 ? 'active' : ''" @click="changeTab(2)">{{ $t('tradeFollow.title3') }}</div>
        </div>
        <div class="list-box flex-wrap">
          <div class="list" v-for="(item, i) in userList" :key="i" @click="toDetail(item)">
            <div class="flex-center info">
              <div class="header">
                <img :src="headerUrl" alt="">
              </div>
              <div class="flex-1">
                <div class="name flex-center-start">
                  <span>{{resetName(item.Name)}}</span>
                </div>
                <div class="email">
                  {{resetEmail(item.Email)}}
                </div>
              </div>
              <div class="btn" @click.stop="toFollow(item)">
                <Button>{{$t('follow.btn1')}}</Button>
              </div>
            </div>
            <div class="flex-wrap user-trade-info">
              <div class="box flex-column-start-center border border-right">
                <div class="label">{{$t('follow.label1')}}(USDT)</div>
                <div class="count green">{{item.TotalProfit.toFixed(2)}}</div>
              </div>
              <div class="box flex-column-end-center border">
                <div class="label">{{$t('follow.label2')}}</div>
                <div class="count ">{{item.TotalTrade}}</div>
              </div>
              <div class="box flex-column-start-center border-right">
                <div class="label">{{$t('follow.label3')}}</div>
                <div class="count ">77/100</div>
              </div>
              <div class="box flex-column-end-center">
                <div class="label">{{$t('follow.label4')}}(USDT)</div>
                <div class="count green">{{item.TotalProfit.toFixed(2)}}</div>
              </div>
            </div>
          </div>
        </div>

        <pageBar :total="page.total" @changePage="changePage"></pageBar>
      </div>


    </div>


  </div>
</template>
<script>
import { Button, Tabs, Tab, List } from 'vant'
import { copyTradeList, copyTradeLog, copyTradeStatistics, copyTradeOrderList } from '@/api/trade'
import { resetName, resetEmail } from '@/utils/common'
import pageBar from '@/components/pageBar'
export default {
  name: 'home',
  components: {
    Button,
    Tabs,
    Tab,
    List,
    pageBar
  },
  data() {
    return {
      tabIndex: 1,
      userType: 1,
      orderIndex: 0,
      page: {
        page: 1,
        limit: 10,
        total: 1
      },
      userPage: {
        page: 1,
        limit: 10
      },
      orderPage: {
        page: 1,
        limit: 10
      },
      isInit: false,
      loading: false,
      finished: false,
      userFinished: false,
      orderFinished: false,
      totalPage: 1,
      userTotalPage: 1,
      orderTotalPage: 1,
      eyeUrl: require('../../assets/imgs/icon-eye.png'),
      eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
      bgUrl: require('../../assets/imgs/follow-bg.png'),
      headerUrl: require('../../assets/imgs/icon-user.png'),
      levelObj: {
      },
      userList: [],
      userListBak: [],
      followUserList: [],
      allFollowUserList: [],
      showMoney: true,
      userMoney: 0.00,
      bitMoney: '0.00',
      myFollowList: [],
      statisticsData: {
        OptionTodayProfit: '0.00',
        OptionTotalAmount: '0.00',
        ContractTodayProfit: '0.00',
        ContractTotalAmount: '0.00',
      },
      orderStatus: 0,
      orderCount: 0
    }
  },
  watch: {
    $route(to, from) {
      if (to.meta.index < from.meta.index) {
        this.transitionName = 'slide-right'
      } else if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left'
      }

      let name = to.name
      if (name != 'trade') {
        this.menuIndex = -1
      }
    }
  },
  computed: {
     moneyStr() {
      return this.showMoney ? parseFloat(this.userMoney).toFixed(4) : '****'
    },
    tabList() {
      return [`${this.$t('follow.order1')}(${this.orderCount})`, this.$t('follow.order2'), this.$t('follow.order3'), this.$t('follow.order4')]
    },
    currencyVal() {
      return this.$store.state.currencyVal
    },
    currencyRate() {
      return this.$store.state.currencyRate
    },
  },
  mounted() {
    let index =  sessionStorage.getItem('followIndex')
    this.init()
    this.onLoadOrder()
    this.initFollowUserList()
    this.initStatistics()
    this.bitMoney = this.userMoney * this.currencyRate
  },
  methods: {
    resetEmail,
    resetName,
    changeTab(i) {
      this.tabIndex = i
      this.userList = this.userListBak.filter(v => {
        let type = this.tabIndex == 1 ? 'option' : 'contract'
        return v.Type == type
      })
    },
    back() {
      this.$router.go(-1)
      sessionStorage.setItem('followIndex', 1)
    },
    changeMoneyType() {
      this.showMoney = !this.showMoney
    },
    initStatistics() {
      copyTradeStatistics().then(res => {
        this.statisticsData = res.data
      })
    },
    toPath(path, query) {
      if (path) {
        this.$router.push({
          name: path,
          query: query || {}
        })
      }
    },
    changeType(type) {
      this.userType = type
      this.followUserList = this.allFollowUserList.filter(v => {
        return v.Status == this.userType
      })
    },
    toDetail(data) {
      sessionStorage.setItem('copyTradeData', JSON.stringify(data))
      this.$router.push({
        name: 'followDetail',
        query: {
          id: data.ID
        }
      })
    },
    toFollow(data) {
      sessionStorage.setItem('copyTradeData', JSON.stringify(data))
      this.$router.push({
        name: 'tradeFollow'
      })
    },
    changePage(page) {
      this.page.page = page
      this.init()
    },
    init() {
      this.loading = true
      let form = new FormData()
      form.append('current', this.page.page)
      form.append('pageSize', this.page.limit)
      copyTradeList(form).then(res => {
        this.userListBak = res.data.Items
        this.userList = res.data.Items.filter(v => {
          let type = this.tabIndex == 1 ? 'option' : 'contract'
          return v.Type == type
        })
        this.page.total = res.data.Pagination.totalRecords
      })
    },
    onLoadUser() {
      this.userPage.page += 1
      this.initFollowUserList(true)
    },
    initFollowUserList(isAdd) {
      this.loading = true
      let form = new FormData()
      form.append('current', this.userPage.page)
      form.append('pageSize', this.userPage.limit)
      copyTradeLog(form).then(res => {
        if (isAdd) {
          this.allFollowUserList = this.allFollowUserList.concat(res.data.Items)
        } else {
          this.allFollowUserList = res.data.Items
        }
        this.followUserList = this.allFollowUserList.filter(v => {
          return v.Status == this.userType
        })
        this.userTotalPage = res.data.Pagination ? res.data.Pagination.totalPage : 1
        if (this.userTotalPage <= this.userPage.page) {
          this.userFinished = true
        }
        this.isInit = true
        this.loading = false
      }).catch(err => {
        this.isInit = true
        this.loading = false
      })
    },
    onLoadOrder() {
      this.orderPage.page += 1
      this.initFollowOrder(true)
    },
    initFollowOrder(isAdd) {
      this.loading = true
      let form = new FormData()
      form.append('current', this.orderPage.page)
      form.append('pageSize', this.orderPage.limit)
      form.append('Status', this.orderStatus)
      copyTradeOrderList(form).then(res => {
        if (isAdd) {
          this.myFollowList = this.myFollowList.concat(res.data.Items)
        } else {
          this.myFollowList = res.data.Items
        }
        this.orderTotalPage = res.data.Pagination ? res.data.Pagination.totalPage : 1
        if (this.orderTotalPage <= this.orderPage.page) {
          this.orderFinished = true
        }
        this.isInit = true
        this.loading = false
      }).catch(err => {
        this.isInit = true
        this.loading = false
      })
    },
    changeTabs() {
      if (this.orderIndex == 3) {
         this.userPage.page = 1
        this.initFollowUserList()
      } else if (this.orderIndex == 0) {
        this.orderPage.page = 1
        this.orderStatus = 0
        this.initFollowOrder()
      } else if (this.orderIndex == 1) {
        this.orderPage.page = 1
        this.orderStatus = 1
        this.initFollowOrder()
      }
    }
  }
}
</script>